import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ToastMessageOptions } from 'primeng/api';

import { ODataMessage } from 'src/app/@shared/utilities/odata/message';
import { FcmMessage } from 'src/app/@core/services/notifications/firebase-messaging.service';

@Injectable({
    providedIn: 'root',
})
export class MessageServiceBroker {
    // Behaviour subjects
    private _messages$: BehaviorSubject<ToastMessageOptions[]> = new BehaviorSubject<ToastMessageOptions[]>([]);

    // Observable the different components can subscribe to
    public readonly messages$: Observable<any> = this._messages$.asObservable();

    public sendMessage(message: ToastMessageOptions) {
        this._messages$.next([message]);
    }

    public sendFCMMessage(message: FcmMessage) {
        if (!message.notification) return;

        let severity = 'secondary';
        let life = 5000;
        switch (message.data?.['severity']) {
            case 'S': severity = 'success'; life = 2000; break;
            case 'E': severity = 'error';   life = 10000; break;
            case 'W': severity = 'warn';    life = 10000; break;
            case 'A': severity = 'contrast'; life = 10000; break;
        }

        this._messages$.next([{
            severity,
            summary: message.notification.title,
            detail: message.notification.body,
            life,
        }]);
    }

    public sendODataMessages(messages: ODataMessage[]) {
        if (messages.length === 0) {
            return;
        }
        let messagesDisp: ToastMessageOptions[] = [];

        for (let i = 0; i < messages.length; i++) {
            let severity = '';
            let life = 0;
            switch (messages[i].type) {
                case 'S':
                    severity = 'success';
                    life = 2000;
                    break;
                case 'A':
                    severity = 'contrast';
                    life = 10000;
                    break;
                case 'E':
                    severity = 'error';
                    life = 10000;
                    break;
                case 'I':
                    severity = 'info';
                    life = 5000;
                    break;
                case 'W':
                    severity = 'warn';
                    life = 10000;
                    break;
                default:
                    severity = 'secondary';
                    life = 5000;
            }

            let detail: string = messages[i].longText || '';
            if (!!messages[i].uuid) {
                detail += '\nIdentifiant de la requête :\n' + messages[i].uuid;
            }

            messagesDisp.push({
                severity: severity,
                summary: messages[i].shortText || '',
                detail: detail,
                id: messages[i].number || 0,
                life: life,
            })
        }

        this._messages$.next(messagesDisp);
    }
}
